export const SB_SEARCH_QUERY = {
  PER_PAGE: 'per_page',
  PAGE: 'page',
  SEARCH_TERMS: 'search_term',
  STARTS_WITH: 'starts_with',
  EXCLUDING_SLUG: 'excluding_slugs',
  RESOLVE_LINKS: 'resolve_links',
  SEARCH: 'search',
};
